import { Sector } from '../../models/interfaces/sector.interface';

const createdAt = new Date('2024-01-01T00:00:00.000Z');
const updatedAt = new Date('2024-01-01T00:00:00.000Z');

export const sectors: Sector[] = [
  { id: 'sector-1', name: 'Tecnologia', createdAt, updatedAt, isActive: true },
  { id: 'sector-2', name: 'Marketing', createdAt, updatedAt, isActive: true },
  { id: 'sector-3', name: 'Vendas', createdAt, updatedAt, isActive: true },
  { id: 'sector-4', name: 'Recursos Humanos', createdAt, updatedAt, isActive: true },
  { id: 'sector-5', name: 'Financeiro', createdAt, updatedAt, isActive: true },
  { id: 'sector-6', name: 'Operacoes', createdAt, updatedAt, isActive: true },
  { id: 'sector-7', name: 'Juridico', createdAt, updatedAt, isActive: true },
  { id: 'sector-8', name: 'Pesquisa', createdAt, updatedAt, isActive: true },
];
